import { render, staticRenderFns } from "./NavMenuDesktop.vue?vue&type=template&id=01348e7b&scoped=true&"
import script from "./NavMenuDesktop.vue?vue&type=script&lang=js&"
export * from "./NavMenuDesktop.vue?vue&type=script&lang=js&"
import style0 from "./NavMenuDesktop.vue?vue&type=style&index=0&id=01348e7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01348e7b",
  null
  
)

export default component.exports